/***
 * @file:èå
 * @author: linkun.he
 * @Date: 2019-06-03 10:11:13
 */
import { Component, Input, OnInit } from '@angular/core';
import { cloneDeep, isEmpty } from 'lodash';

/***
 * åçº§å«èåç»ä»¶
 * */
const TOP_OVERFLOW_FIRST_MENU = {
  moduleLevel: 1,
  moduleOrder: 4,
  css: '',
  icon: '',
  action: null,
  asMenu: true,
  children: null,
  hasChildren: true,
  ids: ['TOP_OVERFLOW_FIRST_MENU'],
  moduleDesc: null,
  moduleId: null,
  moduleName: '...',
  moduleNameEn: '...',
  name: '...',
  parentId: null,
  url: null,
};

@Component({
  selector: 'dt-menu-nodes',
  templateUrl: './menu-nodes.component.html',
  styleUrls: ['./menu-nodes.component.scss'],
})
export class MenuNodesComponent implements OnInit {
  isFirstLevel = false;

  @Input() collapsed: boolean;
  @Input() topMenu: boolean;
  @Input() isAllMenuData: boolean;
  @Input() topMenuItemsNumber: number;
  @Input() data: any;

  ngOnInit() {
    // è®¾ç½®é¡¶é¨ä¸çº§èå`...`éèé¨å
    if (this.isAllMenuData && this.topMenu && this.levelAndOrder.moduleLevel === 1) {
      this.cutOverflowMenu();
    }

    // å¤æ­æ¯å¦ä¸ºä¸çº§èå
    if (this.data && this.levelAndOrder) {
      this.isFirstLevel = this.levelAndOrder.moduleLevel === 1 ? true : false;
    }
  }

  // è®¡ç®ä¸çº§èåæ¶ç¼©é¨å
  cutOverflowMenu() {
    if (this.data.length <= this.topMenuItemsNumber) {
      return;
    }

    const overflowMenu = [];
    const showMenu = [];
    const oldData = cloneDeep(this.data);
    const menuPatch = cloneDeep(TOP_OVERFLOW_FIRST_MENU);

    oldData.forEach((item) => {
      Number(item.moduleLevel) === 1 && Number(item.moduleOrder) > this.topMenuItemsNumber
        ? overflowMenu.push(item)
        : showMenu.push(item);
    });

    this.addModuleLevel(overflowMenu);
    menuPatch.children = overflowMenu;
    showMenu.push(menuPatch);
    this.data = showMenu;
  }

  // æ¶ç¼©çä¸çº§èååä¸ºäºçº§èå
  addModuleLevel(datas) {
    datas.forEach((data) => {
      data.moduleLevel++;
      data.ids.push(TOP_OVERFLOW_FIRST_MENU.ids[0]);
      if (data.hasChildren) {
        this.addModuleLevel(data.children);
      }
    });
  }

  // è®¡ç®èåèç¹å®¹å¨æ ·å¼
  calculateStyle() {
    if (!this.data) {
      return;
    }

    if (this.topMenu) {
      return this.topMenuStyle;
    } else if (this.collapsed) {
      return this.leftMenuStyle;
    }
  }

  // é¡¶é¨èå
  get topMenuStyle() {
    if (!this.levelAndOrder) {
      return;
    }
    const { moduleLevel } = this.levelAndOrder;
    // console.log('moduleLevel-->', moduleLevel);
    // console.log('moduleName-->', moduleName);

    let top;
    let left;
    let position;
    let flex;
    switch (moduleLevel) {
      case 1:
        top = '0';
        position = 'relative';
        flex = 'flex';
        break;
      case 2:
        top = '66px';
        position = 'absolute';
        break;
      default:
        top = '-5px';
        position = 'absolute';
        left = '161px';
        break;
    }
    return {
      top,
      left,
      position,
      zIndex: '999',
      display: flex,
    };
  }

  // å·¦ä¾§èå
  get leftMenuStyle() {
    const { moduleLevel } = this.levelAndOrder;

    let left;
    let top;
    let bottom;

    switch (moduleLevel) {
      case 1:
        left = '0';
        top = '12px';
        break;
      case 2:
        left = '80px';
        top = '0';
        break;
      default:
        left = '161px';
        bottom = '0px';
        break;
    }
    return {
      top,
      left,
      bottom,
      position: 'absolute',
      minWidth: '100%',
    };
  }

  get levelAndOrder() {
    if (isEmpty(this.data)) {
      return;
    }
    const { moduleLevel, moduleOrder } = this.data[0];
    return {
      moduleLevel,
      moduleOrder,
    };
  }
}
